import React, { useEffect, useState } from 'react';
import api from '../../services/api';

const statCards = [
  { key: 'total', label: 'Total de Usuários', icon: '👥', color: '#1e40af' },
  { key: 'active', label: 'Usuários Ativos', icon: '✅', color: '#16a34a' },
  { key: 'lojistas', label: 'Lojistas', icon: '🏪', color: '#7c3aed' },
  { key: 'new_last_30_days', label: 'Novos (30 dias)', icon: '🆕', color: '#d97706' },
];

export default function DashboardPage() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/users/stats')
      .then((res) => setStats(res.data.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div style={styles.pageHeader}>
        <h1 style={styles.pageTitle}>Dashboard</h1>
        <p style={styles.pageDesc}>Visão geral da plataforma BringHub Frete</p>
      </div>

      <div style={styles.statsGrid}>
        {statCards.map((card) => (
          <div key={card.key} style={styles.statCard}>
            <div style={{ ...styles.statIcon, background: `${card.color}15`, color: card.color }}>
              {card.icon}
            </div>
            <div>
              <div style={styles.statValue}>
                {loading ? '—' : (stats?.[card.key] ?? 0)}
              </div>
              <div style={styles.statLabel}>{card.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={styles.infoGrid}>
        <div style={styles.infoCard}>
          <h2 style={styles.infoTitle}>📋 Status dos Usuários</h2>
          {loading ? (
            <p style={styles.loading}>Carregando...</p>
          ) : (
            <div style={styles.statusList}>
              {[
                { label: 'Ativos', value: stats?.active, color: '#16a34a' },
                { label: 'Bloqueados', value: stats?.blocked, color: '#dc2626' },
                { label: 'Pendentes', value: stats?.pending, color: '#d97706' },
              ].map((item) => (
                <div key={item.label} style={styles.statusRow}>
                  <div style={styles.statusDot(item.color)} />
                  <span style={styles.statusLabel}>{item.label}</span>
                  <span style={styles.statusCount}>{item.value ?? 0}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={styles.infoCard}>
          <h2 style={styles.infoTitle}>🚀 Próximas Funcionalidades</h2>
          <div style={styles.roadmapList}>
            {[
              { label: 'Integração Correios', status: 'Em desenvolvimento' },
              { label: 'Integração Jadlog', status: 'Planejado' },
              { label: 'Cotação de Fretes', status: 'Planejado' },
              { label: 'Emissão de Etiquetas', status: 'Planejado' },
              { label: 'Rastreamento Centralizado', status: 'Planejado' },
            ].map((item) => (
              <div key={item.label} style={styles.roadmapItem}>
                <span style={styles.roadmapLabel}>{item.label}</span>
                <span style={styles.roadmapStatus}>{item.status}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  pageHeader: { marginBottom: '28px' },
  pageTitle: { fontSize: '24px', fontWeight: '700', color: '#111827' },
  pageDesc: { fontSize: '14px', color: '#6b7280', marginTop: '4px' },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
    gap: '16px',
    marginBottom: '24px',
  },
  statCard: {
    background: '#ffffff',
    borderRadius: '12px',
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    border: '1px solid #f3f4f6',
  },
  statIcon: {
    width: '48px',
    height: '48px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '22px',
    flexShrink: 0,
  },
  statValue: { fontSize: '26px', fontWeight: '700', color: '#111827', lineHeight: 1.2 },
  statLabel: { fontSize: '13px', color: '#6b7280', marginTop: '2px' },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
    gap: '16px',
  },
  infoCard: {
    background: '#ffffff',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    border: '1px solid #f3f4f6',
  },
  infoTitle: { fontSize: '16px', fontWeight: '600', color: '#111827', marginBottom: '16px' },
  loading: { color: '#9ca3af', fontSize: '14px' },
  statusList: { display: 'flex', flexDirection: 'column', gap: '12px' },
  statusRow: { display: 'flex', alignItems: 'center', gap: '10px' },
  statusDot: (color) => ({
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    background: color,
    flexShrink: 0,
  }),
  statusLabel: { flex: 1, fontSize: '14px', color: '#374151' },
  statusCount: { fontSize: '16px', fontWeight: '600', color: '#111827' },
  roadmapList: { display: 'flex', flexDirection: 'column', gap: '10px' },
  roadmapItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 0',
    borderBottom: '1px solid #f3f4f6',
  },
  roadmapLabel: { fontSize: '14px', color: '#374151' },
  roadmapStatus: {
    fontSize: '12px',
    color: '#6b7280',
    background: '#f3f4f6',
    padding: '2px 8px',
    borderRadius: '12px',
  },
};
